import NotificationPanel from '../Notification';
import {cutTheText} from '../utils/utils';
import classNames from 'classnames';
import {Messages} from '../../../services/lang/messages';

interface ISnackbarTextContainer {
  message: string;
  title?: string;
  docUrl?: string;
  type?: string;
}

const SnackbarTextContainer = ({message, title, docUrl, type}: ISnackbarTextContainer) => {
  return (
    <div data-type={type} className='snackbar__content'>
      {title ? <p className='snackbar__title'>{title}</p> : null}
      <p className={classNames({snackbar__title: !title, snackbar__message: title})}>{message}</p>
      {docUrl && (
        <div className='snackbar__link'>
          <a href={docUrl} rel='noreferrer' target={'_blank'}>
            <span>{Messages.Controls.Details}</span>
          </a>
        </div>
      )}
    </div>
  );
};

interface Template {
  message: string;
  type: string;
  onClickClose: () => void;
  title?: string;
  docUrl?: string;
}

const SnackbarTemplate = ({message, type, onClickClose, title, docUrl}: Template): JSX.Element | null => {
  return (
    <NotificationPanel type={type} onCloseClick={onClickClose}>
      <SnackbarTextContainer docUrl={docUrl} message={cutTheText(message)} title={title} type={type} />
    </NotificationPanel>
  );
};

export default SnackbarTemplate;
